module.exports = __webpack_public_path__ + "static/img/img2.2271e85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img2.png
// module id = Tl22
// module chunks = 1